import type Echo from "laravel-echo";

/**
 * Estados de conexão WebSocket
 */
export enum ConnectionState {
    DISCONNECTED = "disconnected",
    CONNECTING = "connecting",
    CONNECTED = "connected"
}

/**
 * Tipo do contexto Echo
 */
export interface EchoContextType {
    /** Instância do Laravel Echo */
    echo: Echo | null;
    /** Estado atual da conexão */
    connectionState: ConnectionState;
    /**
     * Subscreve a um canal e evento
     * @param channelName Nome do canal (ex: "mesas.1", "notificacoes.user.5")
     * @param eventName Nome do evento (ex: "MesaAtualizada", "NovaNotificacao")
     * @param callback Função chamada quando o evento é recebido
     * @returns Função para cancelar a subscrição
     */
    subscribe: (channelName: string, eventName: string, callback: (data: any) => void) => () => void;
    /**
     * Remove a subscrição de um canal e evento
     * @param channelName Nome do canal
     * @param eventName Nome do evento
     */
    unsubscribe: (channelName: string, eventName: string) => void;
}

/**
 * Opções do hook useEchoSubscription
 */
export interface UseEchoSubscriptionOptions {
    /** Nome completo do canal (ex: "mesas.1", "notificacoes.user.5") */
    channelName: string;
    /** Mapa de evento -> handler */
    events: Record<string, (data: any) => void>;
    /** Controla se a subscrição está ativa (default: true) */
    enabled?: boolean;
    /** Callback chamado quando a conexão é restaurada após desconexão */
    onConnectionRestored?: () => void;
    /** Callback chamado quando ocorre um erro de conexão */
    onConnectionError?: (error: any) => void;
}

/**
 * Retorno do hook useEchoSubscription
 */
export interface UseEchoSubscriptionReturn {
    /** Instância do Laravel Echo (null se não estiver disponível) */
    echo: Echo | null;
    /** Estado atual da conexão */
    connectionState: ConnectionState;
}

/**
 * Props do EchoProvider
 */
export interface EchoProviderProps {
    children: React.ReactNode;
}
